export default __webpack_public_path__ + "static/media/omar.859c64b6.png";